import { render, staticRenderFns } from "./RecruitList.vue?vue&type=template&id=0af8a65d"
import script from "./RecruitList.vue?vue&type=script&lang=js"
export * from "./RecruitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports